import {
  Flexbox, Form, Modal, Styles,
} from '@/components'
import { CLIENT_SYSTEM, singularSystemMapLabel } from '@/constants/clients'
import yup from '@/lib/yupPt'
import clients from '@/services/api/clients'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { toast } from 'react-toastify'

const schema = yup.object().shape({
  clientName: yup.string().required(),
  system: yup.string().required(),
})
function FormClient({ onAdded }) {
  const [active, setActive] = useState(false)
  const [loading, setLoading] = useState(false)

  async function onSubmit(values) {
    try {
      setLoading(true)
      const { data } = await clients.create(values)
      onAdded(data)
      setActive(false)
      toast.success(`${values.clientName} adicionado`)
    } catch (e) {
      toast.error(e.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Styles.Button onClick={() => setActive(true)} className="btn-primary">
        <i className="fas fa-plus" />
        &nbsp;Adicionar
      </Styles.Button>
      {
        active && (
          <fieldset disabled={loading}>
            <Form.Formik
              initialValues={{ clientName: '', system: '' }}
              validationSchema={schema}
              onSubmit={onSubmit}
            >
              {
                ({
                  errors, touched, isValid, dirty,
                }) => (
                  <Form.ValidationForm>
                    <Modal.Base className="active">
                      <Modal.Overlay onClick={() => setActive(false)} />
                      <Modal.Container>
                        <Modal.Header>
                          <Modal.Close onClick={() => setActive(false)} />
                          <Modal.Title>Novo Client</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <Modal.Content>
                            <Flexbox.Columns>
                              <Flexbox.Column className="col-12">
                                <Form.Group className={`${touched?.clientName && errors?.clientName ? 'has-error' : ''}`}>
                                  <Form.Label htmlFor="clientName">Nome <span className="text-error">*</span></Form.Label>
                                  <Form.ValidationField
                                    name="clientName"
                                    autoFocus
                                    id="clientName"
                                    autoComplete="off"
                                    placeholder="Nome do client"
                                  />
                                  {
                                    touched?.clientName && errors?.clientName
                                      ? <Form.Hint>{errors.clientName}</Form.Hint> : null
                                  }
                                </Form.Group>
                              </Flexbox.Column>
                              <Flexbox.Column className="col-12">
                                <Form.Group>
                                  <Form.Label htmlFor="system">Sistema <span className="text-error">*</span></Form.Label>
                                  <Form.ValidationField name="system">
                                    {
                                      ({ field }) => (
                                        <Form.Select
                                          // eslint-disable-next-line react/jsx-props-no-spreading
                                          {...field}
                                          id="system"
                                          placeholder="Sistema"
                                        >
                                          <option value="">Selecione</option>
                                          {
                                            Object.values(CLIENT_SYSTEM).map((value) => (
                                              <option key={`client-system-${value}`} value={value}>{ singularSystemMapLabel[value] || value}</option>
                                            ))
                                          }
                                        </Form.Select>
                                      )
                                    }
                                  </Form.ValidationField>
                                </Form.Group>
                              </Flexbox.Column>
                            </Flexbox.Columns>
                          </Modal.Content>
                        </Modal.Body>
                        <Modal.Footer>
                          <Styles.Button
                            type="submit"
                            className={`btn-primary ${loading ? 'loading' : ''}`}
                            disabled={!dirty || !isValid}
                          >
                            <i className="fas fa-save" />
                            &nbsp;Salvar
                          </Styles.Button>
                        </Modal.Footer>
                      </Modal.Container>
                    </Modal.Base>
                  </Form.ValidationForm>
                )
              }
            </Form.Formik>
          </fieldset>
        )
      }
    </>
  )
}

FormClient.propTypes = {
  onAdded: PropTypes.func.isRequired,
}

export default FormClient
